import {normalizeCronExpression} from './cron';

// V4 account billing: an ERPNext customer reference (free text) and a cron interval.

// Presets: the first of the period at 00:00. Any other expression is Custom.
export const V4_BILLING_INTERVALS = [
  {value: '0 0 1 * *', labelKey: 'monthly', defaultLabel: 'Monthly'},
  {value: '0 0 1 1,4,7,10 *', labelKey: 'quarterly', defaultLabel: 'Quarterly'},
  {value: '0 0 1 1,7 *', labelKey: 'halfYearly', defaultLabel: 'Half-yearly'},
  {value: '0 0 1 1 *', labelKey: 'yearly', defaultLabel: 'Yearly'},
];
export const V4_BILLING_INTERVAL_CUSTOM = 'custom';

export const storedV4BillingCustomer = billing =>
  (typeof billing?.customer === 'string' ? billing.customer : '');

export const storedV4BillingInterval = billing =>
  (typeof billing?.interval === 'string' ? billing.interval : '');

export const v4BillingIntervalPreset = interval => {
  const cron = normalizeCronExpression(interval);
  return V4_BILLING_INTERVALS.find(i => i.value === cron)?.value || null;
};

export const buildV4BillingIntervalOptions = t => [
  ...V4_BILLING_INTERVALS.map(i => ({value: i.value, label: t(i.labelKey, i.defaultLabel)})),
  {value: V4_BILLING_INTERVAL_CUSTOM, label: t('custom', 'Custom')},
];

// The `billing` to send, or undefined to leave it out; null inputs are untouched.
export function v4BillingUpdate(current, {customer = null, interval = null} = {}) {
  if (customer === null && interval === null) return undefined;
  const storedCustomer = storedV4BillingCustomer(current).trim();
  const storedInterval = storedV4BillingInterval(current);
  const nextCustomer = customer === null ? storedCustomer : String(customer).trim();
  const nextInterval = interval === null ? storedInterval : normalizeCronExpression(interval);
  if (!nextCustomer) return storedCustomer ? null : undefined;
  if (nextCustomer === storedCustomer && nextInterval === storedInterval) return undefined;
  return nextInterval ? {customer: nextCustomer, interval: nextInterval} : {customer: nextCustomer};
}
